// extracted by mini-css-extract-plugin
module.exports = {"section":"title-content-background-module--section--35nzY"};